<nb-card class="modal-full">
  <nb-card-header>
    <div class="start inline-flex">
      <span *ngIf="context == 'game'">Game media gallery</span>
      <span *ngIf="context == 'template'">Template media gallery</span>
    </div>
    <div class="end ml-4">
      <button type="submit" class="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
          *ngIf="templateId && gameId" (click)="switchContext()">
        <span *ngIf="context == 'game'">Select from template gallery</span>
        <span *ngIf="context == 'template'">Select from game gallery</span>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="my-3">
      <input type="text" id="voice-search" 
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5" 
        placeholder="Search..." [(ngModel)]="searchText" (keyup)="search()">
    </div>
    <div class="collection" [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="large" nbSpinnerMessage="Loading...">
      <div class="grid grid-cols-6 gap-4" *ngIf="filteredMedias">
    
        <div *ngFor="let media of filteredMedias; let i = index" class="relative h-auto max-w-full rounded-lg" (click)="select(media)">
          <img [src]="media.thumbFileURL ? media.thumbFileURL : media.fileURL" *ngIf="media.type !== 'video'">
          <video controls width="100%" preload="metadata" webkit-playsinline playsinline *ngIf="media.type == 'video'">
            <source [src]="media.fileURL" type="video/mp4">
          </video>
          <div class="absolute bottom-0 left-0 right-0 px-4 py-2 bg-gray-800 opacity-70" *ngIf="media.description">
            <!--<h3 class="text-xl text-white font-bold">{{media.description}}</h3>-->
            <p class="mt-2 text-sm text-gray-300">{{media.description}}</p>
          </div>
        </div>
        <h6 *ngIf="filteredMedias.length == 0 && !loading" class="ml-4 mt-4">
          No media found
        </h6>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="row">
      <button class="cancel" nbButton status="danger" (click)="cancel()">Cancel</button>
    </div>
  </nb-card-footer>
</nb-card>
